import React, { useEffect, useState, useRef } from "react";
import {
    Button, Input, Popconfirm, Tag
} from "antd";
import { useSelector, useDispatch } from "react-redux";
import { setConfigSelectedBehavior, setConfigSelectedTarget, setSavantReadIsInitial, setSavantReadMessage, setStep, setToEditData } from "../../../store/components/MarketExplorer.slice";
import { getCountryCode, saveTargetBuilder } from "../../../utils/oneintelligence/OneIntelligenceHelper";
import MarketExplorerContainer from "./MarketExplorerContainer";
import useAutoFocus from "../../../hooks/autofocus/useAutoFocus";
import OneIntelligenceServices from "../../../services/OneIntelligence.services";
import TrackFeatureServices from "../../../services/TrackFeature.services";
import { setScrapeTopicBrand } from "../../../store/components/BuildTargets.slice";
import { isHasScrapeTopicBrandPermission } from "../../../utils/MainHelper";
import KeywordSuggestions from "./KeywordSuggestions";
import useKeywordSuggestion from "../../../hooks/minified/useKeywordSuggestion";

const TargetInput = function () {
    const dispatch = useDispatch();
    const freeFormInputRef = useRef();
    const {
        configuration: {
            toEditData, savantReadMessage, savantReadIsInitial, selectedTarget
        }
    } = useSelector((state) => state.marketExplorer);
    const { setup } = useSelector((state) => state.buildTargets);
    const { generalMarketCategoriesData, audienceSpecificCategoriesData, categoryDeepDiveData } = useSelector((state) => state.reports);
    const [modelInput, setModelInput] = useState("");
    const [inputText, setInputText] = useState([]);

    const {
        kwsuggestionList,
        loadingKWSuggestion,
        getSuggestionKeywords,
    } = useKeywordSuggestion()

    const handleInputEnter = (value) => {
        if (value && !inputText.includes(value)) {
            setInputText([...inputText, value])
        }
        if (savantReadIsInitial) dispatch(setSavantReadIsInitial(false));
        setModelInput("");
    };
    const setMessages = (msg) => dispatch(setSavantReadMessage(msg));

    const removeText = (value) => {
        setInputText((prev) => {
            return [...prev].filter((text) => text !== value)
        });
        if (freeFormInputRef.current) freeFormInputRef.current.focus();
    };

    const savantReadStatusCallback = (status) => {
        setMessages(status);
    };

    const onClickSuggestion = (kw, isAdd) => {
        setMessages("");
        if (isAdd) {
            setInputText((prev) => {
                // return [...prev, kw]
                return [kw]
            })
        } else {
            setInputText((prev) => {
                return prev.filter((text) => text !== kw)
            })
        }
        if (savantReadIsInitial) dispatch(setSavantReadIsInitial(false));
    }
    const renderCrawlMessage = (savantReadMessage = "") => {
        if (isHasScrapeTopicBrandPermission() && savantReadMessage.includes("Savant:")) {
            savantReadMessage = <>
                {savantReadMessage?.replace("Savant:", "") + " or "}
                <Button type="link" className="oi-kb-btn" onClick={() => {
                    // dispatch(setScrapeTopicBrand(inputText));
                    window.open("https://oneknowledge.sqreemtech.com/")
                }}>Add New to My Own Knowledge Base</Button>
            </>
        } else savantReadMessage = savantReadMessage?.replace("Savant:", "");

        return savantReadMessage
    }

    useEffect(() => {
        if (savantReadMessage.includes("Savant:") && inputText.length) {
            getSuggestionKeywords(inputText, true)
        }
    }, [inputText, savantReadMessage])

    useEffect(() => {
        let listsubjects = null;
        if (inputText.length && !savantReadIsInitial) {
            const region = getCountryCode("savant");
            if (!region) {
                alert("No savant region");
                return;
            }
            let usedUrl = ""
            const { startMonitor, endMonitor } = TrackFeatureServices.getMonitor({ featureKey: "advanceSavantRead" })
            const callBackGetUrl = (params, url) => {
                usedUrl = url
                startMonitor(params, { url: usedUrl })
            }
            const cancelCallback = () => {
                endMonitor({ message: "Cancel API Call." }, { url: usedUrl })
            }
            const audienceTarget = async (recall) => {
                const keywords = inputText.map((text) => text.toLocaleLowerCase())
                setMessages("Crawling SQREEM knowledge base...");
                listsubjects = await OneIntelligenceServices.listSubjects(
                    100,
                    keywords,
                    region,
                    0,
                    savantReadStatusCallback,
                    cancelCallback,
                    callBackGetUrl
                );
                listsubjects.thenpromise
                    .then((resp) => {
                        if (!recall) endMonitor(resp, usedUrl)
                        if (!resp) return;
                        if (!resp.isSuccess && resp?.message?.includes("not loaded")) {
                            setMessages("Country is not loaded.");
                        } else if (resp.notLoaded) {
                            setMessages("Country is not loaded.");
                        } else if (resp.stillLoading) {
                            setMessages("Country is still loading please wait.");
                        } else if (resp.noresult) {
                            setMessages("No Result.");
                        } else {
                            const respKeywords = resp.data || resp.response?.data;
                            const resultkeywords = OneIntelligenceServices.filterSavantKeywords(respKeywords);
                            if (resultkeywords.isError) {
                                setMessages(resultkeywords.error);
                            } else {
                                setMessages("");
                            }
                        }
                    });
            };
            audienceTarget();
        } else if (savantReadIsInitial) {
            setMessages("");
            console.log("Updated initial");
        }
        return () => {
            if (listsubjects) listsubjects.cancel(true);
        };
    }, [inputText, savantReadIsInitial]);

    useEffect(() => {
        if (toEditData.data && toEditData.mode === "edit") {
            const newListText = [...toEditData.data.targets];
            setInputText(newListText.map((i) => i.name));
        }
    }, [toEditData]);

    useAutoFocus(freeFormInputRef);

    const clearSelected = () => {
        if (savantReadMessage) setMessages("");
        dispatch(setConfigSelectedTarget(null));
        dispatch(setConfigSelectedBehavior(null));
        dispatch(setToEditData({
            data: null,
            mode: ""
        }));
    };
    const onCancelFunction = () => {
        setInputText([]);
        if (toEditData.mode) {
            dispatch(setStep(3));
        } else {
            dispatch(setStep(1));
        }
        clearSelected();
    };
    const hasData = (generalMarketCategoriesData.length || audienceSpecificCategoriesData.length || categoryDeepDiveData.length);
    const onSaveTargets = () => {
        const newTargets = inputText.map((txt) => ({
            name: txt,
            children: [{
                name: txt
            }]
        }));
        saveTargetBuilder(newTargets);
    };

    const disabledSetTarget = (inputText.length === 0 || savantReadMessage) || JSON.stringify(toEditData?.data?.targets || []) === JSON.stringify(inputText);
    return (
        <MarketExplorerContainer
            title={selectedTarget?.text || "Products or brands"}
            className="reportBuilder-leftside_targets-input"
        >
            <div className="line">
                <div className="separator" />
            </div>
            <div className="inputSection">
                {
                    inputText.length !== 0 && (
                        <div className="tagSection" key="tagSectionKey">
                            {inputText.map((item, index) => (
                                <div key={item} className="d-flex flex-wrap align-items-center" style={{ gap: "1mm" }}>
                                    <Tag className="oi-tag" closable onClose={() => removeText(item)} key={item}>{item}</Tag>
                                    {inputText[index + 1] ? <span className="and" key={`and-${item}`}>and</span> : null}
                                </div>
                            ))}
                        </div>
                    )
                }
                <Input
                    ref={freeFormInputRef}
                    bordered={false}
                    value={modelInput}
                    onChange={(e) => setModelInput(e.target.value)}
                    onPressEnter={(e) => {
                        handleInputEnter(modelInput.trim());
                    }}
                />
            </div>
            {(savantReadMessage && inputText.length) ? (
                <div style={{
                    color: savantReadMessage.includes("Crawling") || savantReadMessage.includes("/") ? "#52c41a" : "#ff4d4f",
                    fontWeight: "500",
                    fontSize: "3.5mm"
                }}
                >
                    {renderCrawlMessage(savantReadMessage)}
                </div>
            ) : null}
            {
                savantReadMessage.includes("Savant:") ? <KeywordSuggestions
                    onClick={onClickSuggestion}
                    loading={loadingKWSuggestion}
                    list={kwsuggestionList}
                    included={inputText}
                /> : <div className="description">Enter your target to add value to this target group.</div>
            }
            <div className="action-container">
                {(savantReadMessage && inputText.length) ? (
                    <Popconfirm
                        placement="bottomLeft"
                        title="Crawling SQREEM knowledge base is not yet complete. Are sure you want to cancel?"
                        onConfirm={onCancelFunction}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Button>
                            Cancel
                        </Button>
                    </Popconfirm>
                ) : (
                    <Button onClick={onCancelFunction}>
                        Cancel
                    </Button>
                )}
                {(hasData) ? (
                    <Popconfirm
                        placement="bottomLeft"
                        title="The existing report will be removed. Are you sure you want to continue?"
                        onConfirm={onSaveTargets}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Button
                            type="primary"
                            disabled={disabledSetTarget}
                        >
                            Set Target
                        </Button>
                    </Popconfirm>
                ) : (
                    <Button
                        onClick={onSaveTargets}
                        type="primary"
                        disabled={disabledSetTarget}
                    >
                        Set Target
                    </Button>
                )}
            </div>
        </MarketExplorerContainer>
    );
};

export default TargetInput;
